import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const otherRateService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/other-rate/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/other-rate/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/other-rate', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/other-rate/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/other-rate/${id}`)
      return response.data
    },
}